export default {
  orderStatus: {
    0: "Hai inviato l'ordine, attendi che l'agente di acquisto riceva l'ordine",
    23: "L'agente di acquisto ha ricevuto l'ordine ed è in contatto con il venditore",
    22: 'La tua merce è stata ordinata, numero di transazione: ',
    5: 'Il venditore ha spedito, metodo di spedizione: ',
    10: 'Il tuo prodotto è arrivato al magazzino designato di Acbuy',
    16: 'La sua richiesta di reso è stata inviata. Attenda mentre il suo agente la elabora',
    17: 'La sua richiesta di sostituzione è stata inviata. Attenda mentre il suo agente la elabora',
    buyerReturn:
      'L’agente ha inviato una richiesta di reso a causa delle esigenze del cliente, dei rischi dell’articolo, ecc. Attendere il completamento della procedura',
    buyerReplace:
      'L’agente ha inviato una richiesta di sostituzione a causa delle esigenze del cliente, dei rischi dell’articolo, ecc. Attendere il completamento della procedura',
    20: "L'ordine è stato restituito",
    beenReturned: ' Controlla i rimborsi >',
    30: "Il tuo articolo è stato spedito, controlla il pacco per sapere dov'è: ",
    43: 'La tua richiesta di reso è stata annullata',
    44: 'La tua richiesta di cambio è stata annullata',
    49: "Prolungamento dello stoccaggio non pagato. L'articolo è considerato volontariamente abbandonato.",
  },
  expressNo: 'Numero di tracciamento: ',
}
